import React, {use} from 'react'
import Canada from './Canada'
import China from './China'
import Default from './Default'
import SouthKorea from './SouthKorea'
import UnitedStates from './UnitedStates'
import {ConsentExperienceContext} from '../ConsentExperienceContext'
import type {GeneralConsentLanguageProps} from './types'

type ConsentLanguageProps = GeneralConsentLanguageProps & {
  implicitOptIn: boolean
}

function ConsentLanguage({children, implicitOptIn, ...props}: ConsentLanguageProps) {
  const {selectedCountry} = use(ConsentExperienceContext)
  const countryCode = selectedCountry?.alpha || ''
  const Component = getComponent(countryCode, {implicitOptIn})
  // eslint-disable-next-line react-hooks/static-components
  return <Component {...props}>{children}</Component>
}

function getComponent(country: string, options: {implicitOptIn: boolean}): React.FC<GeneralConsentLanguageProps> {
  switch (country) {
    case 'CA':
      return Canada
    case 'CN':
      return China
    case 'KR':
      return SouthKorea
    case 'US':
      if (options.implicitOptIn) {
        return UnitedStates
      }
      return Default
    default:
      return Default
  }
}

export default ConsentLanguage
